/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { MdOutlineErrorOutline } from "react-icons/md";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DropOutModal from "../../../components/ModalComponents/DropOutModal";
import ShareModal from "../../../components/ModalComponents/ShareModal";
import { useAppDispatch } from "../../../useStore";
import { reset } from "../../../features/Applicant/applicantSlice";
import { EntriesPerPage, Search, TableFetch } from "../../../components/TableOptions";
import ScreeningModal from "../../../components/ModalComponents/ScreeningModal";
import Pagination from "../../../components/Pagination";
import swal from "sweetalert";
import moment from "moment";
import XLoader from "../../../components/XLoader";
import ScreeningDrawerComponent from "../ApplicantDrawerComponent/ScreeningDrawerComponent";
import { FaFilePdf, FaFileCsv, FaFileImage, FaFile } from 'react-icons/fa';
import PdfViewer from "../../../components/PdfViewer";
import ImageLightbox from "../../../components/ImageLightbox";
import ReplaceID from "../../../components/ModalComponents/ReplaceID";
import EditApplicant from "../../../components/ModalComponents/EditApplicant";

const NewApplicantTable = ({
  setResetID,
  pageHeader,
  headerTitles,
  data,
  isLoading,
  message,
  isError,
}: any) => {

  const dispatch = useAppDispatch();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]); // State to hold selected IDs
  const [selectedItems, setSelectedItems] = useState<any[]>([]); // State to hold selected items
  const [displayData, setDisplayData] = useState([]);
  const handleCheckboxChange = (itemId: string, item: any) => {
    setIsDrawerOpen(true);
    // Check if the item's ID is already selected
    if (selectedIds.includes(itemId)) {
      // Remove the ID from the selectedIds array
      setSelectedIds(selectedIds.filter((id) => id !== itemId));
      setSelectedItems((prevSelectedItems) => prevSelectedItems.filter((i) => i.id !== itemId));
    } else {
      // Add the ID to the selectedIds array
      setSelectedIds([...selectedIds, itemId]);
      setSelectedItems((prevSelectedItems) => [...prevSelectedItems, item]);
    }
  };




  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    if (isError) {
      swal({
        title: "error",
        text: message,
        icon: "error"
      })
      dispatch(reset())
    }
  }, [dispatch, isError, message])


  const [datas, setDatas] = useState([]);
  const [searchItem, setSearchItem] = useState("");

  const [entriesperpage, setEntriesPerPage] = useState(() => {
    return "8";
  });


  useEffect(() => {
    const result = data?.data?.filter((item: any) =>
      item?.firstName?.toLowerCase()?.includes(searchItem) ||
      item?.middleName?.toLowerCase()?.includes(searchItem) ||
      item?.LastName?.toLowerCase()?.includes(searchItem)
    );
    setDatas(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, searchItem]);

  const [show, setShow] = useState(false);
  const [isPDF, setIsPDF] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const openModal = (fileUrl: any, fileType: string, file: React.SetStateAction<null>) => {
    setSelectedFile(file);
    setIsPDF(fileType === 'pdf');
    setShow(true);
  };


  const getFileIcon = (fileType: any) => {
    switch (fileType) {
      case 'pdf':
        return <FaFilePdf color={"red"} size={25} />;
      case 'csv':
        return <FaFileCsv size={25} color={"green"} />;
      case 'jpeg':
      case 'jpg':
      case 'png':
        return <FaFileImage size={25} color={"gray"} />;
      default:
        return <FaFile size={25} />;
    }
  };



  return (
    <section className="md-ui component-data-table">
      <header className="main-table-header">
        <div className="main-table-search-container">
          <h1 className="table-header--title">{pageHeader}</h1>
          <Search searchItem={searchItem} setSearchItem={setSearchItem} placeholder={pageHeader} />
          <div>
            <EntriesPerPage
              data={datas}
              entriesperpage={entriesperpage}
              setEntriesPerPage={setEntriesPerPage}
            />
          </div>
          <span className="table-header--icons">
            <Link to="/addNewApplicant" className="applicant-btn">
              <Button className="view-HIRED-profile">New Applicant</Button>
            </Link>
          </span>
        </div>
      </header>

      {isLoading && <XLoader isLoading={isLoading} />}

      <div className="main-table-wrapper">
        <table className="main-table-content table-container ">
          <thead className="data-table-header">
            <tr className="data-table-row">
              {headerTitles?.map((title: any, i: any) => (
                <td
                  className="table-datacell datatype-string headerTitles"
                  key={i}
                >
                  {title}
                </td>
              ))}
            </tr>
          </thead>

          <tbody className="data-table-content">
            {isLoading ? (
              <TableFetch colSpan={12} />
            ) : displayData?.length === 0 ||
              displayData?.length === undefined ? (
              <tr>
                <td className="table-msg" colSpan={12}>
                  <MdOutlineErrorOutline size={75} />
                  <p>No Record found!</p>
                </td>
              </tr>
            ) : (
              displayData?.map((item: any, i: any) => (
                <tr className="data-table-row" key={i}>
                  <td>
                    <div className="md-checkbox">
                      <input id={i}
                        type="checkbox"
                        checked={selectedIds?.includes(item?.id)}
                        onChange={() => handleCheckboxChange(item?.id, item)} />
                      <label htmlFor={i}>
                      </label>
                    </div>
                  </td>
                  <td className="table-datacell datatype-string">
                    <div className="dropdown">
                      <button className="dropbtn">
                        <MoreHorizIcon />
                      </button>
                      <div className="dropdown-content"  >
                        <a>
                          <ScreeningModal
                            title="Send for Screening"
                            name={[item]}
                            id={[item.id]}
                          />
                        </a>

                        <a>
                          <DropOutModal
                            title="Dropout"
                            id={item.id}
                            name={`${item.firstName || ''} ${item.middleName || ''} ${item.LastName || ''}`.trim()}
                          />
                        </a>

                        <a>
                          <ShareModal
                            title="Share"
                            applicationId={item.id}
                          />
                        </a>
                      </div>
                    </div>
                  </td>

                  <td className="table-datacell datatype-string">
                    {!item?.title ? "n/a" : item?.title}
                  </td>
                  <td className="table-datacell datatype-numeric toggle">
                    {item?.firstName} {item?.middleName} {item?.LastName}
                  </td>
                  <td className="table-datacell datatype-string">
                    {item?.gender}
                  </td>
                  <td className="table-datacell datatype-string">
                    {moment(!item?.dateOfBirth ? "n/a" : item?.dateOfBirth).format("DD-MM-YYYY")}
                  </td>
                  <td className="table-datacell datatype-string">
                    {!item?.email ? "n/a" : item?.email}
                  </td>

                  <td className="table-datacell datatype-string">
                    <Link
                      to={`/viewapplicants/${item?.id}`}
                      className="applicant-btn"
                    >
                      <Button className="view-job-profile">View</Button>
                    </Link>
                  </td>
                  <td className="table-datacell datatype-string">
                    {item?.verificationID
                      ? (

                        <div className="table-datacell-flex">
                          <span
                            style={{ marginRight: '5px', cursor: 'pointer' }}
                            onClick={() => {
                              const fileExtension = item.verificationID.split('.').pop().toLowerCase();
                              openModal(item?.verificationID, fileExtension, item.verificationID);
                            }}>
                            {getFileIcon(item?.verificationID.split('.').pop().toLowerCase())}
                          </span>
                          <ReplaceID id={item?.id} setResetID={setResetID} />
                        </div>
                      )
                      : <div className="table-datacell-flex">
                        <span>
                          No ID
                        </span>
                        <ReplaceID id={item?.id} setResetID={setResetID} />
                      </div>
                    }
                  </td>

                  <td className="table-datacell datatype-string">
                    {moment(item?.createdAt).format("DD-MM-YYYY")}
                  </td>

                  <td className="table-datacell datatype-numeric">
                    {!item?.phoneNumber ? "n/a" : item?.phoneNumber}
                  </td>

                  <td className="table-datacell datatype-numeric">
                    {!item?.recruiter ? "n/a" : item?.recruiter}
                  </td>

                  <td className="table-datacell datatype-numeric">
                    {!item?.totalWorkExperience
                      ? "n/a"
                      : item?.totalWorkExperience}
                  </td>

                  <td className="table-datacell datatype-numeric">
                    {!item?.relevantWorkExperience
                      ? "n/a"
                      : item?.relevantWorkExperience}
                  </td>

                  <td className="table-datacell datatype-string">
                    {!item?.currentSalary ? "n/a" : item?.currentSalary}
                  </td>
                  <td className="table-datacell datatype-string">
                    {!item?.expectedSalary ? "n/a" : item?.expectedSalary}
                  </td>
                  <td className="table-datacell datatype-string">
                    <EditApplicant name={item} id={item?.id} />

                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {isPDF ? (
          <PdfViewer fileUrl={selectedFile} setShow={setShow} show={show} />
        ) : (
          <ImageLightbox images={selectedFile} setShow={setShow} show={show} />
        )}
      </div>
      <div className="table-footer">
        <Pagination
          setDisplayData={setDisplayData}
          data={datas}
          entriesperpage={entriesperpage}
          Total={"Applicant"}
        />
      </div>
      <ScreeningDrawerComponent isOpen={isDrawerOpen} onClose={toggleDrawer} data={selectedItems} id={selectedIds} />
    </section >
  );
};

export default NewApplicantTable;
